import { useTranslation } from 'helpers/hooks/useTranslation'
import React, { FC } from 'react'
import styled from 'styled-components'
import Badge from 'uiComponents/atoms/Badge/Badge'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
const StyledBadge = styled(Badge)`
  margin: 40px 5px 0;
`

interface IProps {
  premium: boolean
  sale: boolean
  sponsored: boolean
}

const StoryTeaserBadges: FC<IProps> = ({ premium, sale, sponsored }) => {
  const [t] = useTranslation()
  if (!premium && !sale && !sponsored) {
    return null
  }

  return (
    <Container>
      {premium && <StyledBadge title={t('Premium')} />}
      {sale && <StyledBadge title={t('Sale')} isSale />}
      {sponsored && <StyledBadge title={t('Gesponsert')} />}
    </Container>
  )
}

export default StoryTeaserBadges
